<template>
  <el-form-item :label="label" :required="required">

    <el-select
      v-model="formData"
      :disabled="disabled"
      :placeholder="placeholder"
      value-key="value"
      :size="size"
      @change="updated">

      <el-option-group
        v-for="group in workflows"
          :key="group.label"
          :label="group.label">

        <el-option
          v-for="item in group.options"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>

      </el-option-group>

    </el-select>
  </el-form-item>
</template>

<script>

import PostMixins from '@/mixins/PostMixins'

export default {
  mixins: [PostMixins],

  props: {
    label: {
      type: String,
      default: 'Workflow'
    },
    value: {
//      type: String,
      required: true
    },
    type: {
      type: [Array, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select Workflow'
    },
    helpText: {
      type: String,
      default: null
    }
  },

  methods: {
    success (data) {
      this.workflows = data
    },

    updated (value) {
      this.formData = value
      this.$emit('value', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value,
      workflows: []
    }
  },

  mounted () {
    this.fetchData('workflow/select', this.success, 'workflows')
  }
}
</script>



// WEBPACK FOOTER //
// SelectWorkflow.vue?283c547d